import React from 'react';
import { connect } from 'react-redux';

import { formatter, enumHelper } from '../../utils';
import * as invoiceAdditionActions from '../../redux/invoiceAdditions/actions';
import ENUMS from '../../enums/index';

import Pagination2 from '../../components/Pagination2';
import Spin from '../../components/loading';

class DeletedList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPage: 1,
      itemsPerPage: 10
    };
  }

  componentDidMount() {
    const query = `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`;
    this.props.actions.getAll(query);
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.actions.getAll(query);
    });
  };

  getIconCssClass = val => {
    return val ? 'fal fa-check-square text-success' : 'fal fa-times-square text-danger';
  };

  formatValue = ({ val, isPercent, currency }) => {
    if (isPercent) {
      return `${val} %`;
    }

    const amount = formatter.numberWithCommas(val);
    const postfix = enumHelper.convertEnumValueToTitle(ENUMS.MONEY_UNITS.list, currency);

    return `${amount} ${postfix}`;
  };

  render() {
    const { list = [], loading, error, message, faield, totalRecords } = this.props;
    const { currentPage, itemsPerPage } = this.state;

    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">{locales('titles.deletedsAdditions')}</h3>
          <div>
            <button
              onClick={() => this.props.history.push('/invoice-additions')}
              className="btn btn-default w-5 mx-1"
            >
              <i className="fa fa-reply" />
              {locales('labels.back')}
            </button>
          </div>
        </div>

        <main className="panel panel-default">
          <div className="panel-heading">
            <i className="fas fa-list-alt px-1" />
            {locales('titles.deleted.invoice.additions.list')}
          </div>
          <div className="panel-body">
            <Spin spinning={loading}>
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">{locales('tables.row')}</th>
                    <th className="text-center ">{locales('tables.title')}</th>
                    <th className="text-center">{locales('messages.quantity')}</th>
                    <th className="text-center">{locales('tables.showable')}</th>
                    <th className="text-center">{locales('tables.activated')}</th>
                    <th className="text-center">{locales('tables.deleter')}</th>
                    <th className="text-center">{locales('tables.deletationDate')}</th>
                  </tr>
                </thead>
                <tbody>
                  {list.length ? (
                    list.map((x, ix) => (
                      <tr key={x.id}>
                        <td className="text-center">{(currentPage - 1) * itemsPerPage + ix + 1}</td>
                        <td className="text-center"><strong>{x.title}</strong></td>
                        <td className="text-center">{this.formatValue({ val: x.value, isPercent: x.isPercent, currency: x.currency })}</td>
                        <td className="text-center">
                          <i className={this.getIconCssClass(x.showOnFactor)} />
                        </td>
                        <td className="text-center">
                          <i className={this.getIconCssClass(x.isActive)} />
                        </td>
                        <td className="text-center">{x.deletedFullName}</td>
                        <td className="text-center">{x.deletedAt}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className="col-12 text-center">
                      <td className="alert alert-info" colSpan={12}>
                        {locales('alerts.noRecord')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Spin>
          </div>
        </main>
        <footer className="col-12 d-flex justify-content-center py-2">
          <div className="pagination-container">
            <Pagination2
              totalRecords={totalRecords}
              pageLimit={itemsPerPage}
              pageNeighbours={2}
              onPageChanged={this.onPageChanged}
              currentPage={currentPage}
            />
          </div>
        </footer>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.invoiceAdditionsReducer.deletedInvoiceAdditionsList,
    totalRecords: state.invoiceAdditionsReducer.deletedInvoiceAdditionsTotalRecords,
    loading: state.invoiceAdditionsReducer.deletedInvoiceAdditionsLoading,
    message: state.invoiceAdditionsReducer.deletedInvoiceAdditionsMessage,
    failed: state.invoiceAdditionsReducer.deletedInvoiceAdditionsFailed,
    error: state.invoiceAdditionsReducer.deletedInvoiceAdditionsError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      getAll: query =>
        dispatch(invoiceAdditionActions.getDeletedInvoiceAdditionsList(query))
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletedList);
